export const SET_CANCELLED_ORDER_DATA = "SET_CANCELLED_ORDER_DATA";
export const SET_CANCELLED_ORDER_LOADING = "SET_CANCELLED_ORDER_LOADING";
export const SET_CANCELLED_ORDER_PAGINATION = "SET_CANCELLED_ORDER_PAGINATION";
export const SET_CANCELLED_ORDER_FILTER = "SET_CANCELLED_ORDER_FILTER";
export const SET_CANCELLED_ORDER_SINGLE = "SET_CANCELLED_ORDER_SINGLE";
export const RESET_CANCELLED_ORDER_REDUCER = "RESET_CANCELLED_ORDER_REDUCER";

